module.exports = __webpack_public_path__ + "img/roboty-drogowe.d2494e82.svg";